import { styles } from 'util/style'
import css from './Loader2.module.scss'

type Props = {
  size: number
}

export const Loader2 = ({ size }: Props) => {
  const style = styles({ '--size': size + 'px' })

  return <div className={css.loader} style={style}>
    <span /> <span /> <span /> <span />
  </div>
}
